module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Survey"},"de":{"title":"Umfrage"},"fr":{"title":"Sondage"},"it":{"title":"Sondaggio"}}')
  delete Component.options._Ctor
}
